export const stripProductNumber = (productNumber?: string) => {
	if (!productNumber) {
		console.error("No product number provided");
		return productNumber;
	}
	const variantNumber =
		productNumber?.split("-").length > 1 ? productNumber.split("-")[1] : productNumber.slice(3);
	return variantNumber;
};
